import {
  GridItem,
  Heading,
  HeadingProps,
  HStack,
  Icon,
  LinkBox,
  LinkOverlay,
  Separator,
  SeparatorProps,
  SimpleGrid,
  Stack,
  StackProps,
  Text,
  TextProps,
} from "@chakra-ui/react";
import {ArrowRightIcon} from "@heroicons/react/20/solid";
import {ReactNode} from "react";
import NextLink from "next/link";

export const HoverMenuList = (props: StackProps) => {
  return (
    <Stack
      border="3px solid"
      fontSize="md"
      gap={0}
      py={4}
      borderColor="gray.900"
      rounded="lg"
      bg="gray.800"
      color="white"
      {...props}
    />
  );
};

export const HoverMenuItem = (props: StackProps) => (
  <GridItem asChild>
    <LinkBox asChild>
      <HStack gap={3} align="flex-start" {...props} />
    </LinkBox>
  </GridItem>
);

export const HoverMenuItemHeading = ({children, to, ...props}: {to?: string} & HeadingProps) => (
  <Heading size="sm" lineHeight="1" {...props}>
    {to && (
      <LinkOverlay asChild>
        <NextLink href={to} />
      </LinkOverlay>
    )}
    {children}
    <Icon size="xs" ml={1} mt={-0.5} visibility="hidden" _groupHover={{visibility: "visible"}}>
      <ArrowRightIcon />
    </Icon>
  </Heading>
);

export const HoverMenuItemText = (props: TextProps) => (
  <Text fontSize="sm" color="gray.400" _groupHover={{color: "white"}} {...props}></Text>
);

export const HoverMenuSeparator = (props: SeparatorProps) => (
  <Separator {...props} borderColor="gray.900" borderWidth="2px" />
);

export const HoverMenuSection = ({heading, children, ...props}: {heading: ReactNode} & StackProps) => (
  <Stack gap={6} px={6} py={2} {...props}>
    {heading}
    <SimpleGrid gap={6} templateColumns={["1fr", "1fr", "1fr 1fr"]}>
      {children}
    </SimpleGrid>
  </Stack>
);
